import React from 'react';

const Manage = () => {
    return (
        <div>
            <h1>The manage is coming sooooooooooooooooooooon</h1>
        </div>
    );
};

export default Manage;